import { module } from 'angular';
import { NotificationProvider } from './models/notification';

/**
 * @ngdoc service
 * @name app.Notification
 * @description
 * # Notification
 * Provider in the app.
 */
module('app').provider('Notification', NotificationProvider);
